import { useTranslation } from 'react-i18next';

interface Props {
  hasNextPage: boolean;
  loadNextPage: () => void;
  isLoading: boolean;
}

export default function LoadMoreButton(props: Props) {
  const { t } = useTranslation();
  if (!props.hasNextPage) return null;

  return (
    <div className="flex justify-center">
      <button
        onClick={props.loadNextPage}
        disabled={props.isLoading}
        className="inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-wt-primary focus:ring-offset-2"
      >
        {props.isLoading ? `${t('shared.actions.loading')}...` : t('shared.cta.load_more')}
      </button>
    </div>
  );
}
